import CategoryPage from "./CategoryPage";
const HERO = "https://images.unsplash.com/photo-1758957530781-4ff54e09bee2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwbWluaW1hbGlzdCUyMGFwYXJ0bWVudCUyMGludGVyaW9yJTIwbGl2aW5nJTIwcm9vbXxlbnwwfHx8fDE3NzgxMDY0MDh8MA&ixlib=rb-4.1.0&q=85";
export default function LocationLongue() {
  return <CategoryPage category="rental_long" heroImage={HERO} titleKey="rentalLong" />;
}
